exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unit[data-v-257de86f]{font-size:.18rem;font-weight:400;color:#929dad;margin-left:.04rem}.big-num[data-v-257de86f]{font-size:.28rem;font-family:Roboto-Medium,Roboto;font-weight:500;color:#1f1f1f}.detail-item[data-v-257de86f]{margin-bottom:.32rem}", ""]);

// exports
